var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form-item-wrapper",
    {
      attrs: {
        designer: _vm.designer,
        field: _vm.field,
        rules: _vm.rules,
        "design-state": _vm.designState,
        "parent-widget": _vm.parentWidget,
        "parent-list": _vm.parentList,
        "index-of-parent-list": _vm.indexOfParentList,
        "sub-form-row-index": _vm.subFormRowIndex,
        "sub-form-col-index": _vm.subFormColIndex,
        "sub-form-row-id": _vm.subFormRowId,
      },
    },
    [
      _c("uploadFile", {
        ref: "fieldEditor",
        attrs: {
          "only-image": false,
          onlyRead: _vm.getReadMode(),
          value: _vm.fieldModel,
          "max-length": Number(_vm.field.options.limit),
          "max-size": Number(_vm.field.options.fileMaxSize),
          fileTypes: _vm.field.options.fileTypes,
          url: "",
        },
        on: { input: _vm.handleSuccess },
        model: {
          value: _vm.fieldModel,
          callback: function ($$v) {
            _vm.fieldModel = $$v
          },
          expression: "fieldModel",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }